import React from "react";
import Equifax from "./_components/Equifax/Equifax";
import Experian from "./_components/Experian/Experian";
import Transunion from "./_components/Transunion/Transunion";
import "./CreditReports.scss";

function CreditReports(props) {
  const { report, coApplicantReport, closeReport, open } = props;

  if (report?.issuer?.toLowerCase().includes("equifax")) {
    return (
      <Equifax
        onClose={closeReport}
        open={open}
        report={report}
        coApplicantReport={coApplicantReport}
      />
    );
  } else if (report?.issuer?.toLowerCase().includes("experian")) {
    return (
      <Experian
        onClose={closeReport}
        open={open}
        report={report}
        coApplicantReport={coApplicantReport}
      />
    );
  } else if (report?.issuer?.toLowerCase().includes("transunion")) {
    return (
      <Transunion
        onClose={closeReport}
        open={open}
        report={report}
        coApplicantReport={coApplicantReport}
      />
    );
  }

  return null;
}

export default CreditReports;
